<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component shared/dias/components/search/custom-search-box/custom-search-box.component.ts
-->
<ng-template #anchor></ng-template>
